export default "__VITE_ASSET__CH_i74Hh__"